// Costa Oeste Plaza — project data extracted from the brochure
export const PROJECT = {
  name: "Costa Oeste Plaza",
  tagline: "El epicentro comercial de La Chorrera",
  location: "Vía a La Mitra · La Chorrera, Panamá Oeste",
  developer: "Viviendas de Primera",
  year: 2026,
  contact: {
    phone: "+507 305-1111",
    phoneRaw: "5073051111",
    email: "recepcion@viviendasdeprimera.com",
    whatsapp: "5073051111", // used for wa.me link
    address: "Punta Pacífica, Torre Metro Bank, Piso 10, Ciudad de Panamá",
  },
};

export const METRICS = [
  { value: "3,000", suffix: "", label: "Familias actuales", sublabel: "+ 3,000 nuevas familias en construcción" },
  { value: "2,500", suffix: "", label: "Colaboradores judiciales", sublabel: "Diarios en la nueva Ciudad Judicial" },
  { value: "9,000", suffix: "+", label: "Vehículos diarios", sublabel: "Tráfico obligatorio por Vía a La Mitra" },
  { value: "15,000", suffix: "+", label: "Personas circulando", sublabel: "Sector de alto flujo peatonal" },
];

export const HIGHLIGHTS = [
  { title: "Supermercado Ancla", area: "1,779 m² · En construcción", desc: "Local ancla central en planta baja. Garantizará tráfico constante a toda la plaza." },
  { title: "Estación Delta", area: "Ya operando", desc: "La estación de combustible Delta ya está activa, atrayendo conductores y residentes a diario." },
  { title: "19 Locales Comerciales", area: "54 – 168 m²", desc: "Distribuidos en dos niveles, ideales para retail, gastronomía, salud y servicios." },
  { title: "74 Estacionamientos", area: "Capacidad amplia", desc: "Acceso cómodo para clientes y colaboradores de los locales." },
];

// Ground floor — Nivel 000
export const NIVEL_000 = [
  { id: "L1", number: "1", area: 168.62, status: "Disponible" },
  { id: "L2", number: "2", area: 54.27, status: "Disponible" },
  { id: "L3", number: "3", area: 57.10, status: "Disponible" },
  { id: "L4", number: "4", area: 64.96, status: "Disponible" },
  { id: "L5", number: "5", area: 69.01, status: "Disponible" },
  { id: "L6", number: "6", area: 64.10, status: "Disponible" },
  { id: "L7", number: "7", area: 65.97, status: "Disponible" },
  { id: "L8", number: "8", area: 69.09, status: "Disponible" },
  { id: "L9", number: "9", area: 61.95, status: "Disponible" },
];

// Second level — Nivel 200
export const NIVEL_200 = [
  { id: "L201", number: "201", area: 83.34, status: "Disponible" },
  { id: "L202", number: "202", area: 75.83, status: "Disponible" },
  { id: "L203", number: "203", area: 74.49, status: "Disponible" },
  { id: "L204", number: "204", area: 71.25, status: "Disponible" },
  { id: "L205", number: "205", area: 83.04, status: "Disponible" },
  { id: "L206", number: "206", area: 83.07, status: "Disponible" },
  { id: "L207", number: "207", area: 71.35, status: "Disponible" },
  { id: "L208", number: "208", area: 74.36, status: "Disponible" },
  { id: "L209", number: "209", area: 72.83, status: "Disponible" },
  { id: "L210", number: "210", area: 74.33, status: "Disponible" },
];

export const TENANT_PROFILES = [
  { title: "Restaurantes & Cafeterías", desc: "2,500 colaboradores judiciales necesitan almorzar cada día.", icon: "Utensils" },
  { title: "Farmacias & Clínicas", desc: "3,000 familias residentes (y otras 3,000 en camino) buscando servicios de salud cercanos.", icon: "Stethoscope" },
  { title: "Banca & Servicios", desc: "Oficinas, co-working, courier y servicios profesionales.", icon: "Briefcase" },
  { title: "Ferretería & Hogar", desc: "Demanda constante de 6,000 familias para mejoras y mantenimiento del hogar.", icon: "Wrench" },
];

export const NEARBY = [
  { name: "Ciudad Judicial de La Chorrera", detail: "Al frente — 2,500 colaboradores diarios" },
  { name: "Residencial Costa Oeste", detail: "Paso obligado — 3,000 familias cruzan la plaza para entrar al residencial" },
  { name: "Hospital Nicolás A. Solano", detail: "A pocos pasos — flujo de pacientes, personal médico y visitantes" },
  { name: "Expansión residencial", detail: "Próximas 3,000 familias en construcción" },
  { name: "Vía a La Mitra", detail: "9,000+ vehículos diarios — frente a la plaza" },
];
